import { Container } from './styles';
import ImageGallery from 'react-image-gallery';

import f1 from '../../assets/img/f1.jpg'
import f2 from '../../assets/img/f2.jpg'
import f3 from '../../assets/img/f3.jpg'
import f4 from '../../assets/img/f4.jpg'
import f5 from '../../assets/img/f5.jpg'
import f6 from '../../assets/img/f6.jpg'
import f7 from '../../assets/img/f7.jpg'
import f8 from '../../assets/img/f8.jpg'
import f9 from '../../assets/img/f9.jpg'
import f10 from '../../assets/img/f10.jpg'
import f11 from '../../assets/img/f11.jpg'
import f13 from '../../assets/img/f13.jpg'
import f14 from '../../assets/img/f14.jpg'
import f15 from '../../assets/img/f15.jpg'
import ide3 from '../../assets/img/ide3.jpg'

export function Photos() {

    const images = [
        {
            original: f1,
            thumbnail: f1,
        },
        {
            original: f2,
            thumbnail: f2,
        },
        {
            original: f3,
            thumbnail: f3,
        },
        {
            original: f4,
            thumbnail: f4,
        },
        {
            original: f5,
            thumbnail: f5,
        },
        {
            original: f6,
            thumbnail: f6,
        },
        {
            original: f7,
            thumbnail: f7,
        },
        {
            original: f8,
            thumbnail: f8,
        },
        {
            original: f9,
            thumbnail: f9,
        },
        {
            original: f10,
            thumbnail: f10,
        },
        {
            original: f11,
            thumbnail: f11,
        },
        {
            original: f13,
            thumbnail: f13,
        },
        {
            original: f14,
            thumbnail: f14,
        },
        {
            original: f15,
            thumbnail: f15,
        },
        {
            original: ide3,
            thumbnail: ide3,
        },
    ];

    return (
        <Container id="fotos">
            <h1>Fotos</h1>
            <h2>Nossos lindos momentos nesse local belíssimo que escolhemos para casar.</h2>
            <ImageGallery items={images} autoPlay={true} showThumbnails={true} lazyLoad={true} />
        </Container>
    );
}
